import { Button, toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import DocumentsModal from "../../../components/modals/documentsModal/documentsModal";
import { ToastMessages } from "../../../components/toasts/toastMessages";
import { useDataAccumulatorForSingleOrder } from "../../../context/dataAccumulatorForSingleOrder";
import { ModalId } from "../../../enums/modalId";
import { useMergePdfs } from "../../../hooks/useMergePdfs";
import { useModalOpener } from "../../../hooks/useModalOpener";
import { closeModal, setOpenedModalId } from "../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../redux/store/store";
import { useAttachmentFiles } from "../hooks/useAttachmentFiles";
import { uploadClinicalAttachmentWithToast } from "../utils/uploadClinicalAttachmentWithToast";

interface ManageAttachmentsProps {
  mergedPdfToRender: (file: File) => void;
}

const ManageAttachments = (props: ManageAttachmentsProps) => {
  const { mergedPdfToRender: setMergedPdfOnParent } = props;
  const { generalOrderDetails, authOnFileDetails } =
    useDataAccumulatorForSingleOrder();
  const order = generalOrderDetails?.order ?? null;
  const authOnFile = authOnFileDetails?.auth_on_file ?? null;
  const dispatch = useDispatch<AppDispatch>();
  const [fileNames, setFileNames] = useState<string[]>([]);
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const {
    isMerging,
    mergePdfsFromBase64,
    mergedPdfToRender: mergedPdfFile,
  } = useMergePdfs({
    onSuccess: (mergedFile) => {
      uploadClinicalAttachment(mergedFile, order?.order_id ?? "");
    },
    onFailure: (error) => {
      toast.error(ToastMessages.CLINICAL_ATTACHMENT_UPLOADED_ERROR);
    },
  });
  const { documents, setDocuments, isLoading } = useAttachmentFiles();
  const { openedModalId } = useModalOpener();

  useEffect(() => {
    if (!isMerging && mergedPdfFile) {
      setMergedPdfOnParent(mergedPdfFile);
    }
  }, [mergedPdfFile, isMerging]);

  const uploadClinicalAttachment = async (
    mergedFile: Blob,
    orderId: string,
  ) => {
    await uploadClinicalAttachmentWithToast({
      mergedFile,
      orderId,
      onLoadingChange: setIsUploading,
    });
  };
  return (
    <>
      <Button
        buttonType="secondary"
        size="small"
        onClick={() => {
          dispatch(setOpenedModalId({ id: ModalId.FINAL_DOCUMENT_MODAL }));
        }}
        disabled={isLoading || isUploading}
      >
        Manage Attachments
      </Button>
      {openedModalId === ModalId.FINAL_DOCUMENT_MODAL && (
        <>
          <DocumentsModal
            onClose={() => dispatch(closeModal())}
            documentsName={fileNames}
            documentsList={documents}
            id={order?.order_id ?? ""}
            newDocumentNames={(urls) => setFileNames(urls)}
            newFiles={(files) => setDocuments(files)}
            patientId={order?.demographics?.patient_id ?? ""}
            orderId={order?.order_id ?? ""}
            orderData={{
              demographics: order?.demographics,
              auth_on_file: authOnFile ?? undefined,
            }}
            onMergePdfs={mergePdfsFromBase64}
            isMerging={isMerging}
            shouldRunMergeOnSingleFile={true}
            shouldNotEmit={true}
          />
        </>
      )}
    </>
  );
};

export default ManageAttachments;
